import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SystemCapabilities } from 'adc-sirius-module-common';

type CapabilitiesState = SystemCapabilities & {
  isLoaded?: boolean;
};

export const initialState: CapabilitiesState = {
  canGetStudyData: false,
  canGetStudies: false,
  canGetOrganizations: false,
  canInsertOrganizations: false,
  canInsertUsers: false,
  canGetUsers: false,
  canUpdateUsers: false,
  canInsertAssignments: false,
  canGetAssignments: false,
  canDeleteAssignments: false,
  canAssignSystem: false,
  isLoaded: false,
};

export const capabilitiesSlice = createSlice({
  name: 'capabilities',
  initialState,
  reducers: {
    setCapabilities: (_state, action: PayloadAction<SystemCapabilities>) => {
      return {
        ...initialState,
        ...action.payload,
        isLoaded: true,
      };
    },
  },
});

export const { setCapabilities } = capabilitiesSlice.actions;
export default capabilitiesSlice.reducer;
